import React from "react";

import styles from "./themeButtonContainer.module.less";

export default function ButtonContainer({ children }) {
  return <div className={`${styles.themeButtonContainer}`}>{children}</div>;
}
